import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Mail, MapPin, Phone } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo variant="light" className="h-14 w-auto" />
          <p className="mt-6 text-sm leading-relaxed text-primary-foreground/75 max-w-md">
            Woman-led South African property management firm specialising in
            student accommodation, evaluations and technical services since 2017.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            <span className="overline text-[10px] border border-primary-foreground/25 px-3 py-1.5 rounded-sm">B-BBEE Level 100%</span>
            <span className="overline text-[10px] border border-primary-foreground/25 px-3 py-1.5 rounded-sm">PPRA Registered</span>
            <span className="overline text-[10px] border border-primary-foreground/25 px-3 py-1.5 rounded-sm">Woman-Led</span>
          </div>
        </div>

        <div className="lg:col-span-3">
          <h4 className="overline text-primary-foreground/60 mb-5">Navigate</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/leasing" className="hover:text-secondary transition-colors" data-testid="footer-link-leasing">Leasing</Link></li>
            <li><Link to="/sales" className="hover:text-secondary transition-colors" data-testid="footer-link-sales">For Sale</Link></li>
            <li><Link to="/services" className="hover:text-secondary transition-colors" data-testid="footer-link-services">Services</Link></li>
            <li><Link to="/about" className="hover:text-secondary transition-colors" data-testid="footer-link-about">About</Link></li>
            <li><Link to="/book-appointment" className="hover:text-secondary transition-colors" data-testid="footer-link-book">Book Appointment</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h4 className="overline text-primary-foreground/60 mb-5">Contact</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-secondary" />
              <span>2 Bruton Road, Bryanston, 2191, Johannesburg</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-secondary" />
              <a href="mailto:info@thecampusco.co.za" className="hover:text-secondary" data-testid="footer-email-general">info@thecampusco.co.za</a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-secondary" />
              <a href="tel:+27608362116" className="hover:text-secondary" data-testid="footer-phone">060 836 2116</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Campusco (Pty) Ltd. All rights reserved.</p>
          <p>Managing student accommodation across South Africa.</p>
        </div>
      </div>
    </footer>
  );
};
